import { hubStamp } from '@pathonline/shared';

/** "1 comment", "3 comments" (shared/src/domain/text.ts: the API words its messages the same way). */
export { plural } from '@pathonline/shared';

/** An instant (UTC ISO) as Vilnius wall time, "2026-10-08 16:33"; '' stays ''. */
export function hubDateTime(iso: string): string {
  return hubStamp(iso) || iso;
}

/** A member's roles as shown: "manager + strategist". The main role alone when an answer has no list (one from before roles were added). */
export const rolesText = (m: { group: string; roles?: readonly string[] }): string => (m.roles?.length ? m.roles : [m.group]).join(' + ');
